export default __webpack_public_path__ + "static/SRUS 4362 - Product Specifications & Technical Data-e9c40386d336a3b7ceac3a7f6e77a09f.pdf";